"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    hour: 36e5,
    minute: 6e4,
    second: 1e3,
};
